import React from 'react';
import Helmet from "react-helmet";
import {config} from "../../config";
import {canonical} from "../../libs/helper";
import createLink from "../../libs/createLink";

export const StoryTerms = () => {
    return (
        <div id="charter">
            <Helmet>
                <title>{config.preTitle}Règles de publication d'une histoire{config.postTitle}</title>
                <link rel="canonical" href={canonical(createLink("storiesRules"), "", "storiesRules")} />
            </Helmet>
            <div className="container">
                <div className="card big">
                    <div className="voissa-charter-block">
                        <h3>RÈGLES DE PUBLICATION D'UNE HISTOIRE SUR VOISSA</h3>
                        <p>
                            Afin de proposer des textes de qualité, nous imposons certaines règles aux auteurs si ils souhaitent être publiés.
                        </p>

                        <p>
                            Les règles d'écriture de base ainsi que "l'esprit Voissa" doivent être respectés pour que les lecteurs puissent éprouver du plaisir.
                        </p>
                    </div>
                    <div className="voissa-charter-block">
                        <h3>FORME</h3>
                        <p>
                            Votre histoire doit être aérée et donc proposer une lecture facile. L'histoire doit comporter des paragraphes, des retours à la ligne etc.
                        </p>
                    </div>
                    <div className="voissa-charter-block">
                        <h3>ORTHOGRAPHE / CONJUGAISON</h3>
                        <p>
                            Nous ne demandons pas qu'elle soit parfaite, mais les textes trop mal orthographiés seront refusés. N'hésitez pas à faire relire vos textes par un Voissanaute ou vous faire aider d'un correcteur d'orthographe.
                        </p>

                        <p>
                            Le site <a href={"https://www.scribens.fr/"} target={"_blank"} rel="noopener noreferrer">https://www.scribens.fr</a> propose un service de correction.
                        </p>

                        <p>
                            Si vous avez un doute sur la conjugaison d'un verbe, <a href={"http://leconjugueur.com"} target={"_blank"} rel="noopener noreferrer">leconjugueur.com</a> propose de vous aider.
                        </p>
                    </div>
                    <div className="voissa-charter-block">
                        <h3>QUALITÉ DE L'HISTOIRE</h3>
                        <p>
                            Les textes trop pauvres ne seront pas publiés. Un texte pauvre est une histoire sans intrigue, sans intérêt qui ne donne pas envie à son lecteur de dépasser le premier paragraphe.
                        </p>

                        <p>
                            L'histoire doit avoir un début, un développement et une fin.
                        </p>
                    </div>
                    <div className="voissa-charter-block">
                        <h3>VOL DE CONTENU </h3>
                        <p>
                            Les textes volés sur Internet sont très faciles à identifier. Nous ne les publierons pas par respect pour les droits d'auteur.
                        </p>

                        <p>
                            Comme pour les photos/vidéos les contrevenants s'exposent à un bannissement de Voissa.
                        </p>
                    </div>
                    <div className="voissa-charter-block">
                        <h3>RESPECT DE LA CHARTE VOISSA</h3>
                        <p>
                            Les modérateurs se réservent le choix de ne pas valider un texte trop " limite ".
                        </p>

                        <span className="ul-title">Les textes qui sous entendent :</span>
                        <ul>
                            <li>un lien entre personnes de même famille (inceste) ;</li>
                            <li>l'intervention d'un enfant, d'un mineur ou d'une personne trop "jeune" ;</li>
                            <li>des pratiques sexuelles déviantes (scatophilie, zoophilie etc.) ;</li>
                            <li>des comportements ultra violents (esclavage, viol, contrainte, mépris, maltraitance) ;</li>
                            <li>des comportements haineux (racisme, homophobie).</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
};